<template>
    <div class="work-page">
      <div class="carousel-desktop" v-if="$vuetify.breakpoint.mdAndUp">
          <v-btn :disabled="visibleSlide == 0" v-on:click="prev" fab outlined dark color="white">
              <v-icon class="prev-button" large >mdi-arrow-left</v-icon>
          </v-btn>
          <transition mode="out-in">
            <Slide :index="visibleSlide" :key="visibleSlide"/>
          </transition>
          <v-btn :disabled="visibleSlide == 3" v-on:click="next" fab outlined dark color="white">
              <v-icon class="next-button" large>mdi-arrow-right</v-icon>
          </v-btn>
      </div>
      <div class="carousel-mobile" v-else>
        <Slide
          class="slide-mobile"
          :index="visibleSlide"
          v-on:setIndex="(i)=>{visibleSlide=i}"
        >

        </Slide>
      </div>
    </div>
</template>

<script>
import Slide from '../components/Slide.vue'
import workSlideAnimationBus from '../workSlideAnimationBus'
export default {
  components: {
    Slide
  },
  data () {
    return {
      titleOffsetTweened: 0,
      isMobile: null,
      visibleSlide: 0,
      slideData: [
        { title: 'Interactive', src: require('@/assets/slide1-desktop.png'), srcMobile: require('@/assets/slide1-mobile.png'), alt: 'phone' },
        { title: 'Non-profits', src: require('@/assets/slide2.svg'), srcMobile: require('@/assets/slide2-mobile.svg'), alt: 'laptop' },
        { title: 'Educational', src: require('@/assets/slide3-desktop.png'), srcMobile: require('@/assets/slide3-mobile.svg'), alt: 'two phones' },
        { title: 'Branding', src: require('@/assets/slide4-desktop.png'), srcMobile: require('@/assets/slide4-mobile.png'), alt: 'devices' }
      ]
    }
  },
  methods: {
    next () {
      workSlideAnimationBus.reverseAnimation().then(() => {
        this.visibleSlide += 1
      })
    },
    prev () {
      workSlideAnimationBus.reverseAnimation().then(() => {
        this.visibleSlide -= 1
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.work-page{
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh; /* Fallback for browsers that do not support Custom Properties */
  height: calc(var(--vh, 1vh) * 100);
  .carousel-desktop{
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 3vw;
    height: 100vh; /* Fallback for browsers that do not support Custom Properties */
    height: calc(var(--vh, 1vh) * 100);
    margin: 0 3vw;
  }
  .carousel-mobile{
    .slide-mobile{
      overflow: hidden;
      width: 100vw;
      height: 100vh; /* Fallback for browsers that do not support Custom Properties */
      height: calc(var(--vh, 1vh) * 100);
    }
  }
}
</style>
